import React from "react"

export default function CloseButton({
  className = "closeIconModalPC",
  ...props
}) {
  return (
    <div className={className} onClick={props.onClick}>
      X
    </div>
  )
}
